module.exports = __webpack_public_path__ + "img/thumb_4.d0c5c4d5.jpg";